export default "/images/spain.jpg?b42e0b876ed9eaa6c8b10e2766fdaaa3";